import { gql } from "graphql-request";
import { createGraphQLClient } from "./graphql.service";

export interface PyloApp {
  id: string;
  name: string;
  is_default: boolean;
  created_at?: string;
  pylo_users?: {
    data?: Array<{
      id: string;
    }>;
    pagination: {
      total: number;
    };
  };
}

export const getAppsForCurrentCustomer = async () => {
  const client = createGraphQLClient({ endpointName: "apps-list" });
  const response = await client.request<{
    pyloAppList?: { data?: Array<PyloApp> };
  }>(gql`
    query apps {
      pyloAppList(pagination: { per_page: 10000 }) {
        data {
          id
          name
          is_default
          created_at
          pylo_users(pagination: { per_page: 1 }) {
            data {
              id
            }
            pagination {
              total
            }
          }
        }
      }
    }
  `);

  return response.pyloAppList?.data;
};

export const createApp = async ({ name }: { name: string }) => {
  const client = createGraphQLClient({ endpointName: "create-app" });
  const response = await client.request<{ createPyloApp?: { data?: { id: string } } }>(
    gql`
      mutation createApp($input: CreatePyloAppInput!) {
        createPyloApp(input: $input) {
          data {
            id
          }
        }
      }
    `,
    {
      input: {
        name,
      },
    },
  );
  return response.createPyloApp?.data?.id;
};

export const updateApp = async ({ id, name }: { id: string; name: string }) => {
  const client = createGraphQLClient({ endpointName: "update-app" });
  await client.request(
    gql`
      mutation createApp($input: UpdatePyloAppInput!) {
        updatePyloApp(input: $input) {
          data {
            id
          }
        }
      }
    `,
    {
      input: {
        id,
        name,
      },
    },
  );
};
export const deleteApp = async ({ ids }: { ids: Array<string> }) => {
  const client = createGraphQLClient({ endpointName: "delete-app" });
  await client.request(
    gql`
      mutation deleteApp($ids: [ID!]!) {
        deletePyloApp(ids: $ids) {
          data {
            success
          }
        }
      }
    `,
    {
      ids,
    },
  );
};

export const getAppById = async ({ id }: { id: string }) => {
  const client = createGraphQLClient({ endpointName: "app-by-id" });
  const response = await client.request<{
    pyloAppById?: { data?: PyloApp };
  }>(
    gql`
      query appById($id: ID!) {
        pyloAppById(id: $id) {
          data {
            id
            name
          }
        }
      }
    `,
    { id },
  );
  return response.pyloAppById?.data;
};
